import type React from 'react'
import { memo } from 'react'
import { Box, Spinner } from '@chakra-ui/react'
import type { IProduct } from '@/app/[locale]/_types'
import Filtered from '../Filtered'

interface FilteredDataType {
  products: IProduct[]
  count: number
}

interface FilteredProductsViewProps {
  filteredData: FilteredDataType
  isFetchingNextPage: boolean
  hasNextPage?: boolean
  loadMoreRef: React.RefObject<HTMLDivElement | null>
}

const FilteredProductsView = memo<FilteredProductsViewProps>(
  ({ filteredData, isFetchingNextPage, hasNextPage, loadMoreRef }) => (
    <>
      <Filtered products={filteredData} />
      {isFetchingNextPage &&
        (filteredData?.products?.length || 0) < Number(filteredData?.count) && (
          <Box display='flex' justifyContent='center' py={10}>
            <Spinner size='lg' color='primary' />
          </Box>
        )}
      {hasNextPage && <div ref={loadMoreRef} style={{ height: '10px' }} />}
    </>
  )
)
FilteredProductsView.displayName = 'FilteredProductsView'

export default FilteredProductsView
